var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (template, title) {
      pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["popup","popup--" + template], [false,true]), false, true)) + "\u003E\u003Cdiv class=\"popup__header\"\u003E\u003Cdiv" + (pug.attr("class", pug.classes(["popup__icon","popup__icon--" + template], [false,true]), false, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"popup__title\"\u003E" + (pug.escape(null == (pug_interp = title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"popup__close\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"popup__content\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "template" in locals_for_with ?
        locals_for_with.template :
        typeof template !== 'undefined' ? template : undefined, "title" in locals_for_with ?
        locals_for_with.title :
        typeof title !== 'undefined' ? title : undefined));
    ;;return pug_html;};
module.exports = template;